import { ReactNode } from 'react';

type Props = {
    productLink: ReactNode;
    productImage: ReactNode;
    productDescription: ReactNode;
    quantity?: number;
}

export const ProjectSelectionDevice = ({ productLink, productImage, productDescription, quantity }: Props) => (
    <div className="vss-project-selection-device">
        <div className="vss-project-selection-device__image">
            {productImage}
        </div>

        <div className="vss-project-selection-device__details">
            {productLink}

            <div className="vss-project-selection-device__description">
                {productDescription}
            </div>
        </div>

        {quantity ? (
            <div className="vss-project-selection-device__quantity">
                {quantity}
            </div>
        ) : null}
    </div>
);
